var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"go-back"},[_c('fa-icon',{attrs:{"size":"lg","icon":['fas', 'angle-left']},on:{"click":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }